export type RespostaItem = {
    id: number | null
    resposta: string
    ativo: boolean
    padrao?: string
}

export type RespostasPersonalizadasIzzaModel = {
    boasVindas: RespostaItem
    aceito: RespostaItem
    retiradoBalcao: RespostaItem
    saiuParaEntrega: RespostaItem
    emProducao: RespostaItem
    emProducaoRetirada: RespostaItem
    entregue: RespostaItem
    horarioFuncionamento: RespostaItem
    taxaEntrega: RespostaItem
    contato: RespostaItem
    cardapio: RespostaItem
    formaPagamento: RespostaItem
    tempoEntrega: RespostaItem
    situacaoPedidoNormal: RespostaItem
    situacaoPedidoAtrasado: RespostaItem
    cancelamento: RespostaItem
    alteracao: RespostaItem
    modoIzza: number
    enviarMensagemDeAvaliacaoPedidoPelaIzza: boolean
    bonificarIndicacaoAmigos: boolean
    textoPromocaoIndicacao: string
}

const respostaItemInicial: RespostaItem = { id: null, resposta: "", ativo: true, padrao: "" }

export const RespostasPersonalizadasIzzaInicial: RespostasPersonalizadasIzzaModel = {
    boasVindas: { ...respostaItemInicial },
    aceito: { ...respostaItemInicial },
    retiradoBalcao: { ...respostaItemInicial },
    saiuParaEntrega: { ...respostaItemInicial },
    emProducao: { ...respostaItemInicial },
    emProducaoRetirada: { ...respostaItemInicial },
    entregue: { ...respostaItemInicial },
    horarioFuncionamento: { ...respostaItemInicial },
    taxaEntrega: { ...respostaItemInicial },
    contato: { ...respostaItemInicial },
    cardapio: { ...respostaItemInicial },
    formaPagamento: { ...respostaItemInicial },
    tempoEntrega: { ...respostaItemInicial },
    situacaoPedidoNormal: { ...respostaItemInicial },
    situacaoPedidoAtrasado: { ...respostaItemInicial },
    cancelamento: { ...respostaItemInicial },
    alteracao: { ...respostaItemInicial },
    modoIzza: 0,
    enviarMensagemDeAvaliacaoPedidoPelaIzza: true,
    bonificarIndicacaoAmigos: true,
    textoPromocaoIndicacao: "",
}

export type CampoRespostaIzza = keyof Omit<
    RespostasPersonalizadasIzzaModel,
    | "modoIzza"
    | "enviarMensagemDeAvaliacaoPedidoPelaIzza"
    | "bonificarIndicacaoAmigos"
    | "textoPromocaoIndicacao"
>
